import React from "react";
import * as PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import HourglassFullIcon from "@mui/icons-material/HourglassFull";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import InfoIcon from "@mui/icons-material/Info";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
// import DownloadIcon from "@mui/icons-material/Download";
import Notification from "../Notification";
import { formatDateTime } from "../../utilities";
import RunHistoryDialogDelete from "./RunHistoryDialogDelete";
import RunHistoryDialogLog from "./RunHistoryDialogLog";
import Loading from "../Loading";
// NOTE: Do not use import { Link } from "react-router-dom";

const styles = {
    button: {
        marginTop: "20px",
    },
    failed: {
        color: "red",
        marginTop: "6px",
    },
    note: {
        marginTop: 0,
        marginBottom: "16px",
    },
    succeeded: {
        color: "green",
        marginTop: "6px",
    },
    // table: {
    //     width: "initial",
    //     "& .MuiTableCell-root": {
    //         padding: "0 16px",
    //     },
    // },
    tableContainer: {
        width: "fit-content",
        minWidth: 200,
        maxWidth: 1200,
        maxHeight: 600,
    },
    deleteIcon: {
        // color: "#bc0000",
    },
    downloadIcon: {
        //
    },
    startedAtColumn: {
        width: "200px",
    },
};

const RunHistoryTable = ({ t, ...rest }) => {
    const [state, setState] = React.useState({
        dialogDeleteOpen: false,
        dialogLogOpen: false,
        selectedRunId: undefined,
    });

    const setStateSafely = (newState) => {
        setState((prevState) => ({
            ...prevState,
            ...newState,
        }));
    };

    const onOpenDialogLog = (runId) => {
        setStateSafely({
            dialogLogOpen: true,
            selectedRunId: runId,
        });
    };

    const onCloseDialogLog = () => {
        setStateSafely({
            dialogLogOpen: false,
            selectedRunId: undefined,
        });

        rest.onCloseLog();
    };

    const onOpenDialogDelete = (runId) => {
        setStateSafely({
            dialogDeleteOpen: true,
            selectedRunId: runId,
        });
    };

    const onCloseDialogDelete = () => {
        setStateSafely({
            dialogDeleteOpen: false,
            selectedRunId: undefined,
        });
    };

    const onDeleteRun = () => {
        rest.onDeleteRun(state.selectedRunId);
    };

    const onManualRefresh = () => {
        const el = document.getElementById("refreshIconId");
        el.classList.add("spin");

        el.addEventListener("animationend", () => {
            el.classList.remove("spin");
        });

        rest.onManualRefresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    };

    const sortedRuns = rest.runs.sort((a, b) => b.startedAt - a.startedAt);
    const selectedRun = rest.runs.find((run) => {
        return run.id === state.selectedRunId;
    });

    if (rest.deleting) {
        return (
            <Loading
                loading={rest.deleting}
                message={t("Deleting run...")}
            />
        );
    }

    return (
        <>
            <div>
                <p style={styles.note}>
                    {t("The run history will refresh automatically.")}
                    <IconButton
                        onClick={onManualRefresh}
                        size="small"
                        id="refreshIconId"
                    >
                        <Tooltip title={t("Manual refresh")}>
                            <RefreshIcon />
                        </Tooltip>
                    </IconButton>
                </p>

                <TableContainer style={styles.tableContainer}>
                    <Table
                        className={"myTable2"}
                        stickyHeader
                    >
                        {/* <Table sx={styles.table}> */}
                        <TableHead>
                            <TableRow>
                                <TableCell>{t("Run name")}</TableCell>
                                <TableCell style={styles.startedAtColumn}>{t("Started at")}</TableCell>
                                <TableCell>{t("Status")}</TableCell>
                                <TableCell>{t("Log")}</TableCell>
                                <TableCell>{t("Delete")}</TableCell>
                                {/* <TableCell>{t("Download")}</TableCell> */}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {sortedRuns.map((run) => (
                                <TableRow key={run.name}>
                                    <TableCell>
                                        {run.completed && !run.failed ? (
                                            <Tooltip title={t("Load run")}>
                                                <Link href={`./#/viewrun/survey?run=${run.id}`}>{run.name}</Link>
                                            </Tooltip>
                                        ) : (
                                            <span>{run.name}</span>
                                        )}
                                    </TableCell>
                                    <TableCell>{formatDateTime(run.startedAt)}</TableCell>
                                    <TableCell>
                                        <Tooltip
                                            title={
                                                run.completed
                                                    ? !run.failed
                                                        ? t("Run has completed")
                                                        : t("Run failed")
                                                    : t("Run is in progress")
                                            }
                                        >
                                            {run.completed ? (
                                                <HourglassFullIcon
                                                    sx={!run.failed ? styles.succeeded : styles.failed}
                                                />
                                            ) : (
                                                <HourglassEmptyIcon />
                                            )}
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell>
                                        <IconButton
                                            onClick={() => {
                                                // rest.onFetchLog(run.id);
                                                onOpenDialogLog(run.id);
                                                // rest.onDownloadRunLog(run.id);
                                            }}
                                            size="small"
                                        >
                                            <Tooltip title={t("Log")}>
                                                <InfoIcon />
                                            </Tooltip>
                                        </IconButton>
                                    </TableCell>
                                    <TableCell>
                                        <IconButton
                                            onClick={() => {
                                                onOpenDialogDelete(run.id);
                                            }}
                                            size="small"
                                        >
                                            <Tooltip title={t("Delete")}>
                                                <DeleteIcon style={styles.deleteIcon} />
                                            </Tooltip>
                                        </IconButton>
                                    </TableCell>
                                    {/* <TableCell>
                                        {run.completed && !run.failed ? (
                                            <IconButton
                                                onClick={() => {
                                                    rest.onDownloadDatabases([run.id]);
                                                }}
                                                size="small"
                                            >
                                                <Tooltip title={t("Download")}>
                                                    <DownloadIcon style={styles.downloadIcon} />
                                                </Tooltip>
                                            </IconButton>
                                        ) : (
                                            <span>-</span>
                                        )}
                                    </TableCell> */}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Notification
                    variant={rest.notificationVariant}
                    open={rest.notificationOpen}
                    message={rest.notificationMessage}
                    onClose={rest.onCloseNotification}
                />
            </div>

            <RunHistoryDialogLog
                open={state.dialogLogOpen}
                onClose={onCloseDialogLog}
                selectedRun={selectedRun}
                onFetchLog={rest.onFetchLog}
                log={rest.log}
                onDownloadLog={rest.onDownloadRunLog}
            />

            <RunHistoryDialogDelete
                open={state.dialogDeleteOpen}
                onClose={onCloseDialogDelete}
                selectedRun={selectedRun}
                onDeleteRun={onDeleteRun}
            />
        </>
    );
};

RunHistoryTable.propTypes = {
    loadingData: PropTypes.bool,
    runs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            startedAt: PropTypes.instanceOf(Date).isRequired,
            completed: PropTypes.bool.isRequired,
        })
    ),
    notificationVariant: PropTypes.string,
    notificationOpen: PropTypes.bool,
    notificationMessage: PropTypes.string,
    onDownloadRunLog: PropTypes.func.isRequired,
    onCloseNotification: PropTypes.func.isRequired,
    onDeleteRun: PropTypes.func.isRequired,
    onDownloadDatabases: PropTypes.func.isRequired,
};

RunHistoryTable.defaultProps = {
    loadingData: false,
    runs: [],
    notificationOpen: false,
};

export default withTranslation()(RunHistoryTable);
